import { createContext } from 'react';
import useWebsocket from '../hooks/useWebsocket';
import { useSelector } from 'react-redux';
import { monitoringSelectors } from 'src/selectors';
import { situationsAdapterSelectors } from 'src/redux/slices/situations';

export const ChatContext = createContext({});

const ChatContextProvider = ({ children }) => {
  const socket = useWebsocket();
  const processingSituation = useSelector(
    monitoringSelectors.getSituationToProcess
  );
  const situation = useSelector((state) =>
    situationsAdapterSelectors.selectById(
      state,
      processingSituation?.situationId
    )
  );

  return (
    <ChatContext.Provider
      value={{
        socket,
        situation,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export default ChatContextProvider;
